<!--  -->
<template>
  <div class="tablwbox">
    <div class="srrwrw">
      <div>
        <el-input v-model="paquery.keywords" placeholder="请输入小程序名/appid" style="width:200px;margin-right:10px" />
        <el-select v-model="paquery.admin_group_id" placeholder="请选择管理员组">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          />
        </el-select>
        <el-button type="primary" icon="el-icon-search" style="margin-left:10px" @click="srarch">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="add">新增</el-button>
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="miniprogram_app_id"
        label="小程序appid"
        width="300"
        align="center"
      />
      <el-table-column
        prop="account_name"
        label="小程序名称"
        width="300"
        align="center"
      />
      <el-table-column
        prop="group_name"
        label="管理员组名称"
        width="300"
        align="center"
      />
      <el-table-column
        prop="rank"
        label="优先级"
        width="200"
        align="center"
      />
      <el-table-column
        prop="realName"
        label="创建人"
        width="200"
        align="center"
      />
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        width="200"
        align="center"
      />
      <el-table-column
        prop="created_at_text"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="edit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="新增/编辑"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="25%"
    >
      <adddialog ref="adddialogview" @callback="callback" />
    </el-dialog>
    <pagination-right
      :total="total"
      @size-change="fetchPageSizeone"
      @current-change="fetchCurrentPageone"
    />
  </div>
</template>

<script>
import { officialAccountlistMpRank } from '@/api/sourceMaterial.js'
import { getGroupTreeList } from '@/api/authGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import adddialog from './components/adddialog.vue'
export default {
  name: 'Wechatseting',
  components: {
    adddialog,
    PaginationRight
  },
  data() {
    return {
      dialogVisible: false,
      paquery: {
        page: 1,
        page_size: 10,
        admin_group_id: null,
        keywords: null
      },
      total: null,
      tableData: [],
      options: [],
      qrcode: '',
      loading: false
    }
  },
  created() {
    this.sawrlist()
    this.getapplettype()
  },
  mounted() {

  },
  methods: {
    async getapplettype() {
      const data = await getGroupTreeList()
      this.options = data.data.list
      console.log('data', data)
    },
    async sawrlist() {
      this.loading = true
      const data = await officialAccountlistMpRank(this.paquery)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('data', data)
    },
    fetchPageSizeone(e) {
      this.paquery.page_size = e
      this.sawrlist()
    },
    fetchCurrentPageone(e) {
      this.paquery.page = e
      this.sawrlist()
    },
    srarch() {
      this.paquery.page = 1
      this.sawrlist()
    },
    reset() {
      this.paquery.page = 1
      this.paquery.page_size = 10
      this.paquery.keywords = null
      this.paquery.admin_group_id = null
      this.sawrlist()
    },
    enlarge(url) {
      this.qrcode = url
      this.dialogVisible = true
    },
    add() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.adddialogview.send(1)
      })
    },
    edit(item) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.adddialogview.send(2, item)
      })
    },
    callback() {
      this.dialogVisible = false
      this.sawrlist()
      this.$message({
        message: '操作成功',
        type: 'success'
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tablwbox{
  padding: 20px;
}
.srrwrw{
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.defaultrse{
  color: #E6A23C;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
.fasrw{
  color: #409EFF;
}
</style>
